import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    save: {
        padding: '5px 10px',
        borderRadius: '16px',
        maxHeight: '48px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textTransform: 'uppercase',
        fontWeight: 400,
        fontSize: 14,
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none',
        cursor: 'pointer',
        marginRight: 12,
    },
    bgSave: {
        background: '#00a3f9',
        color: '#24263e',
        border: '1px solid #00a3f9',
    },
    bgCansel: {
        background: 'none',
        color: '#00a3f9',
        border: '1px solid #00a3f9',
    },
    bgOffBonus: {
        color: 'rgb(36, 38, 62)',
        background: 'rgb(255, 206, 1)',
        border: '1px solid rgb(255, 206, 1)',
    },
    wrapBlockButton: {
        width: '100%', 
        display: 'flex', 
        paddingBottom: 12
    }
}))

export {
    useStyles
}